/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";

import "./parcel-list.scss";

import _ from "lodash";
import {Button, Item, Message, Popup, Table} from "semantic-ui-react";
import {Auftragsverwaltung} from "../../../../../../stores/auftragsverwaltung-mobx";
import {Parcel} from "../../../../../../models/parcel";
import {Icon} from "../../../../../../core/components/icon/icon";
import {ParcelStore} from "../../../../../../stores/parcel-store-mobx";

export interface ParcelListProps {
    auftragsverwaltung: Auftragsverwaltung;
    parcelStore: ParcelStore;
    title?: string;
    onAdd?: (e: React.MouseEvent) => void;
    onHover?: (e: React.MouseEvent, parcel: Parcel) => void;
}
interface SortAction {
    type: string;
    column: string;
}


interface ParcelToolsProps {
    parcel: Parcel;
    onDelete: (e: React.MouseEvent, parcel: Parcel) => void;
}

const ParcelTools = ({parcel, onDelete}: ParcelToolsProps) => (
    <>
        <Popup content="Parzelle entfernen"
            trigger={
                <Button className={"delete-parcel"} circular size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        onDelete(e, parcel);
                    }}>
                    <Icon name={"garbage_can"} />
                </Button>
            } />
    </>
);

@observer
export class ParcelList extends Component<ParcelListProps, any> {
    watchHandles: any[] = [];
    constructor(props: ParcelListProps) {
        super(props);
        this.state = {
            error: null,
            column: null,
            data: null,
            direction: null,
        };
        this.sort = this.sort.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState((state: any) =>({
                    data: state.data.reverse(),
                    direction: state.direction === "ascending" ? "descending" : "ascending"
                }));
            } else {
                this.setState((state: any) =>({
                    column: action.column,
                    data: _.sortBy(state.data, [action.column], ["asc"]),
                    direction: "ascending",
                }));
            }
            return;
        default:
            throw new Error();
        }
    }

    componentDidMount(): void {
        // this.loadParcels();
        this.loadDomains();
    }

    componentDidUpdate(): void {}

    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }

    handleCancel(e: React.MouseEvent): void {
        // const {auftragsverwaltung} = this.props;
        // auftragsverwaltung.setEditing(false);
    }

    handleEdit(e: React.MouseEvent, parcel: Parcel): void {
        e.preventDefault();
        // Wenn blur direkt via e.target aufgerufen wird, reklamiert Webstorm:
        // TS2339: Property 'blur' does not exist on type 'EventTarget'.
        const target = e.target as HTMLElement;
        target.blur();

        const {parcelStore} = this.props;

        parcelStore?.setSelectedItem(parcel);
        // auftragsverwaltung.setEditing(true, "energy-source");
    }

    handleDelete(e: React.MouseEvent, parcel: Parcel): void {
        e.preventDefault();
        // Wenn blur direkt via e.target aufgerufen wird, reklamiert Webstorm:
        // TS2339: Property 'blur' does not exist on type 'EventTarget'.
        const target = e.target as HTMLElement;
        target.blur();

        const {parcelStore} = this.props;

        parcelStore?.removeItem(parcel);
        // const {data, column, direction} = this.state;
        //
        // // remove from list and reorder
        // const cleaned = data.filter((es) => es.guid !== parcel.guid);
        // const sorted = _.orderBy(cleaned, [column], [direction]);
        // this.setState({
        //     data: sorted
        // });
    }

    handleSave(parcel: Parcel): void {
        // add new parcel to state and reorder
        const {data, column, direction} = this.state;
        data.push(parcel);
        const sorted = _.orderBy(data, [column], [direction]);
        this.setState({
            data: sorted
        });
    }

    render(): React.ReactElement | null {
        const {parcelStore, onHover} = this.props;
        const {
            column, direction, error
        } = this.state;
        const parcels = parcelStore?.visibleItems;

        if (error) {
            return (
                <Message negative>
                    <Message.Header>Fehler beim Laden der Parzellen</Message.Header>
                    {error}
                </Message>
            );
        }

        if (parcels.length === 0) {
            return (
                <>
                    <Item.Group className={"geo-parcels"}>
                        <Item><Item.Content><p>keine Parzellen ausgewählt</p></Item.Content></Item>
                    </Item.Group>
                </>
            );
        }

        return (
            <>
                <Item.Group className={"geo-parcels"}>
                    <Item>
                        <Item.Content>
                            <Table basic="very" fixed singleLine sortable={(parcels.length > 1)}
                                compact selectable className={"parcels"}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell sorted={column === "id" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "id" })}>
                                            EGRID
                                        </Table.HeaderCell>
                                        <Table.HeaderCell sorted={column === "typeId" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "typeId" })}>
                                            Gmeinde
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={2}
                                            sorted={column === "specification" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "specification" })}>
                                            Nr.
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}></Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {parcels.map((parcel: Parcel) => (
                                        <Table.Row key={parcel.guid}
                                            onMouseEnter={(e) => {
                                                e.preventDefault();
                                                if (onHover) {
                                                    onHover(e, parcel);
                                                }
                                            } } >
                                            <Table.Cell>
                                                {parcel.egrid}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {parcel.municipality}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {parcel.nr}
                                            </Table.Cell>
                                            <Table.Cell className="tools">
                                                <ParcelTools
                                                    parcel={parcel}
                                                    onDelete={(e, p) => this.handleDelete(e, p)}
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </Item.Content>
                    </Item>
                </Item.Group>
            </>
        );
    }

    // private loadParcels() {
    //     const {parcelStore} = this.props;
    //
    //     const parcels = parcelStore?.visibleItems;
    //     const data = _.orderBy(parcels, ["egrid"], ["asc"]);
    //     this.setState({
    //         data,
    //         column: "egrid",
    //         direction: "ascending"
    //     });
    // }

    /**
     * Load domains
     *
     * @private
     */
    private loadDomains() {
        // const {auftragsverwaltung} = this.props;

        // auftragsverwaltung.getShortDomainCodes("parcel", "typeId").then((energySourceTypeCodes) => {
        //     this.setState({
        //         energySourceTypeCodes
        //     });
        // });
        // auftragsverwaltung.getShortDomainCodes("parcel", "priorityId").then((energySourcePriorityTypeCodes) => {
        //     this.setState({
        //         energySourcePriorityTypeCodes
        //     });
        // });
    }

}
